'use es6';

import { createTracker } from 'usage-tracker-public';
import events from 'usage-tracker-developers/events.yaml';
import PortalIdParser from 'PortalIdParser';
import userInfo from 'hub-http/userInfo';
export const initialize = callback => {
  let isAuthed = false;
  const DevelopersTracker = createTracker({
    events,
    properties: {
      namespace: 'developer-docs'
    },
    onError: err => {
      console.error(err);
    },
    isExternalHost: false
  });

  function onAuthReady(cb = () => {}) {
    if (isAuthed) {
      cb();
    } else {
      try {
        userInfo({
          ignoreRedirect: true,
          query: {
            portalId: PortalIdParser.get()
          }
        }).then(({
          portal,
          user
        }) => {
          if (!isAuthed) {
            isAuthed = true;
            DevelopersTracker.setProperties({
              hubId: portal.portal_id,
              email: user.email
            });
          }

          cb();
        }).catch(() => {
          /* No-op */
        });
      } catch (err) {
        /* No-op */
      }
    }
  }

  function trackWhenAuthed(...args) {
    onAuthReady(() => {
      DevelopersTracker.track(...args);
    });
  }

  callback(trackWhenAuthed);
};